import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';
import TwilioConversations from '../components/TwilioConversations';

const CommunicationsPage = () => {
    const [conversationsOpen, setConversationsOpen] = useState(true);

    return (
        <Box sx={{
            width: '100%',
            height: '100vh',
            bgcolor: '#121212',
            color: '#e0e0e0',
            pt: 8, // Account for fixed top menu bar
            overflow: 'hidden'
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 3,
                px: 3 // Add padding to header
            }}>
                <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: '#ffffff' }}>
                    Communications
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<ChatIcon />}
                    onClick={() => setConversationsOpen(true)}
                    sx={{
                        bgcolor: '#2196f3',
                        '&:hover': {
                            bgcolor: '#1976d2'
                        }
                    }}
                >
                    Open Communications
                </Button>
            </Box>

            <Box sx={{
                height: 'calc(100vh - 140px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: 2
            }}>
                {!conversationsOpen && (
                    <>
                        <Typography variant="h5" sx={{ color: '#ffffff', mb: 2 }}>
                            Twilio Communications Hub
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#b0b0b0', textAlign: 'center', maxWidth: 600 }}>
                            Manage your SMS conversations, view call history, and communicate with your contacts
                            through your Twilio communications platform.
                        </Typography>
                        <Button
                            variant="contained"
                            size="large"
                            startIcon={<ChatIcon />}
                            onClick={() => setConversationsOpen(true)}
                            sx={{
                                mt: 3,
                                bgcolor: '#2196f3',
                                '&:hover': {
                                    bgcolor: '#1976d2'
                                }
                            }}
                        >
                            Start Communicating
                        </Button>
                    </>
                )}
            </Box>

            <TwilioConversations
                open={conversationsOpen}
                onClose={() => setConversationsOpen(false)}
            />
        </Box>
    );
};

export default CommunicationsPage;
